module.exports = __webpack_public_path__ + "img/folder.8ecb046a.svg";